import * as React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation('reportCardContent.earnedCSBPlus');
  return (
    <View style={styles.base}>
      <Gutter style={styles.header}>
        <Text variant="heading">
          {tt('title', 'Earned Client Support Bonus+')}
        </Text>
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<LoadingBox style={styles.loadingBoxEarnedOn} />}
          suffix={<LoadingBox style={styles.loadingBoxEarnedOn} />}
        />
      </Gutter>
    </View>
  );
};
